import { Button, FlexBox } from '@Backlot-Cars/archie';

const BackAction = ({ backId, disabled, onBack, backCopy }) => (
	<Button disabled={disabled} id={backId} variant="tertiary" onClick={onBack}>
		{backCopy}
	</Button>
);

const NextAction = ({ isSubmitting, handleSubmit, nextCopy }) => (
	<Button disabled={isSubmitting} onClick={handleSubmit}>
		{nextCopy}
	</Button>
);

const SignUpFormActions = ({
	firstBackUrl = '',
	backCopy = 'Back',
	nextCopy = 'Next',
	backId = 'form-step-back',
	nextId = 'form-step-next',
	backComponent,
	isBackDisabled = false,
	...rest
}) => (
	<FlexBox alignItems="center" width="100%" justifyContent="space-between" flexDirection="row-reverse">
		<NextAction nextCopy={nextCopy} {...rest} />
		{backComponent || (
			<BackAction
				{...rest}
				disabled={isBackDisabled}
				firstBackUrl={firstBackUrl}
				backCopy={backCopy}
				nextCopy={nextCopy}
				nextId={nextId}
				backId={backId}
			/>
		)}
	</FlexBox>
);

export default SignUpFormActions;
